import { MonthlyOtherFee } from "graphql/type";

export const calculateMonthlyRent = (
  monthlyOtherFees: (MonthlyOtherFee | null)[] | null = [],
  monthlyRentValue: number = 0
): number => {
  const fees = monthlyOtherFees ?? [];
  const monthlyTotals = fees.reduce<Record<number, number>>((totals, fee) => {
    if (!fee) return totals;
    const {
      cost: { value },
      applyMonths = [],
    } = fee;

    applyMonths.forEach((month) => {
      totals[month] = (totals[month] ?? 0) + value;
    });

    return totals;
  }, {});

  const maxOtherFee = Object.values(monthlyTotals).reduce((max, fee) => Math.max(max, fee), 0);

  return monthlyRentValue + maxOtherFee;
};
